<template>
  <div class="box-border has-background-white box-h-max">
    <div class="mg-b-5 line-title-dh is-flex is-justify-spacebetween">
      <b-tooltip
        label="Move"
        type="is-dark"
        v-if="user.userLevel == 0"
        position="is-bottom"
      >
        <p
          class="is-size-5 has-text-weight-normal pd-y-10 vue-draggable-handle"
        >
          {{ $t("dashboard.mainDashboardProjectOverview") }}
        </p>
      </b-tooltip>
      <p
        v-else
        class="is-size-5 has-text-weight-normal pd-y-10 vue-draggable-handle"
      >
        {{ $t("dashboard.mainDashboardProjectOverview") }}
      </p>
      <p
        class="pd-y-10 icon-color is-size-5 cr-pointer"
        @click="$emit('openModalInfo', 'po')"
      >
        <i class="fas fa-question-circle"></i>
      </p>
    </div>
    <div
      v-if="
        companyStatus(2) +
          companyStatus(3) +
          companyStatus(1) +
          companyStatus(4) +
          companyStatus(0) >
        0
      "
      class="is-flex is-justify-center"
    >
      <div class="has-text-centered totalCompany">
        <p class="th is-size-3 has-text-weight-normal">
          {{
            (companyStatus(2) +
              companyStatus(3) +
              companyStatus(1) +
              companyStatus(4) +
              companyStatus(0))
              | comma
          }}
        </p>
        <p class="th is-size-3 has-text-weight-normal">
          {{
            companyStatus(2) +
              companyStatus(3) +
              companyStatus(1) +
              companyStatus(4) +
              companyStatus(0) >
            1
              ? $t("message.companiesSuffix")
              : $t("message.companySuffix")
          }}
        </p>
      </div>
    </div>
    <div
      v-if="
        companyStatus(2) +
          companyStatus(3) +
          companyStatus(1) +
          companyStatus(4) +
          companyStatus(0) >
        0
      "
      class="pd-20"
    >
      <Doughnut
        v-if="
          companyStatus(1) !== 0 ||
          companyStatus(2) !== 0 ||
          companyStatus(3) !== 0 ||
          companyStatus(4) !== 0 ||
          companyStatus(0) !== 0
        "
        :width="220"
        :height="220"
        :labels="[
          $t('dashboard.ProjectOverviewAchieved'),
          $t('dashboard.ProjectOverviewDeactive'),
          $t('dashboard.ProjectOverviewInprocess'),
          $t('dashboard.ProjectOverviewSucceed'),
          $t('dashboard.ProjectOverviewInactive'),
        ]"
        :bgColor="['#209cee', '#b5b5b5', '#23d160', '#00a79d', '#c6c6c6']"
        :numData="[
          companyStatus(2),
          companyStatus(3),
          companyStatus(1),
          companyStatus(4),
          companyStatus(0),
        ]"
        :tooltipsOpen="true"
      />
      <Doughnut
        v-else
        :width="220"
        :height="220"
        :labels="[
          $t('dashboard.ProjectOverviewAchieved'),
          $t('dashboard.ProjectOverviewDeactive'),
          $t('dashboard.ProjectOverviewInprocess'),
          $t('dashboard.ProjectOverviewSucceed'),
          $t('dashboard.ProjectOverviewInactive'),
        ]"
        :bgColor="['#209cee', '#b5b5b5', '#23d160', '#00a79d', '#c6c6c6']"
        :numData="[0, -1, 0, 0]"
      />
    </div>
    <div
      v-if="
        companyStatus(2) +
          companyStatus(3) +
          companyStatus(1) +
          companyStatus(4) +
          companyStatus(0) >
        0
      "
      class="is-flex is-justify-center"
    >
      <div class="pd-20">
        <p
          class="is-size-6 has-text-dark is-flex is-align-center pd-5 has-text-weight-normal"
        >
          <b-icon pack="fas" icon="circle" class="has-text-grey-light"></b-icon>
          {{ $t("dashboard.ProjectOverviewInactive") }}: {{ companyStatus(0) }}
          {{
            companyStatus(0) > 1
              ? $t("message.companiesSuffix")
              : $t("message.companySuffix")
          }}
        </p>
        <p
          class="is-size-6 has-text-dark is-flex is-align-center pd-5 has-text-weight-normal"
        >
          <b-icon pack="fas" icon="circle" class="has-text-success"></b-icon>
          {{ $t("dashboard.ProjectOverviewInprocess") }}:
          {{ companyStatus(1) }}
          {{
            companyStatus(1) > 1
              ? $t("message.companiesSuffix")
              : $t("message.companySuffix")
          }}
        </p>
        <p
          class="is-size-6 has-text-dark is-flex is-align-center pd-5 has-text-weight-normal"
        >
          <b-icon pack="fas" icon="circle" class="has-text-info"></b-icon>
          {{ $t("dashboard.ProjectOverviewAchieved") }}: {{ companyStatus(2) }}
          {{
            companyStatus(2) > 1
              ? $t("message.companiesSuffix")
              : $t("message.companySuffix")
          }}
        </p>
        <p
          class="is-size-6 has-text-dark is-flex is-align-center pd-5 has-text-weight-normal"
        >
          <b-icon pack="fas" icon="circle" class="text-batch"></b-icon>
          {{ $t("dashboard.ProjectOverviewSucceed") }}: {{ companyStatus(4) }}
          {{
            companyStatus(4) > 1
              ? $t("message.companiesSuffix")
              : $t("message.companySuffix")
          }}
        </p>
        <p
          class="is-size-6 has-text-dark is-flex is-align-center pd-5 has-text-weight-normal"
        >
          <b-icon pack="fas" icon="circle" class="has-text-grey-light"></b-icon>
          {{ $t("dashboard.ProjectOverviewDeactive") }}: {{ companyStatus(3) }}
          {{
            companyStatus(3) > 1
              ? $t("message.companiesSuffix")
              : $t("message.companySuffix")
          }}
        </p>
      </div>
    </div>
    <div
      v-else
      class="has-text-centered th is-size-5 pd-20 is-flex is-align-center is-justify-center h-100-per"
    >
      <p>*** {{ $t("dashboard.notfound") }} ***</p>
    </div>
  </div>
</template>

<script>
import Doughnut from "../../charts/Doughnut";
export default {
  components: {
    Doughnut,
  },
  computed: {
    startupLists() {
      return this.$store.getters.startupLists;
    },
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    companyStatus(status) {
      let filter = this.startupLists.filter(
        (item) => item.statusActive === status
      );
      return filter.length;
    },
  },
};
</script>

<style  scoped>
.totalCompany {
  position: relative;
  top: 160px;
  line-height: 35px;
}
</style>